import { render, staticRenderFns } from "./NavAlignment.vue?vue&type=template&id=7db4fd2a&"
import script from "./NavAlignment.vue?vue&type=script&lang=js&"
export * from "./NavAlignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports